const MentionsType = {
    TEAM: 'team',
    PUBLIC: 'public',
} as const;

export default MentionsType;